import { cn, NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { WorkerAvatar } from '../ServiceWorker/WorkerAvatar';
import type { CarGroup } from './notificationGroupTypes';
import { isSilenced } from './notificationReach';
import type { NotificationGroupOverviewTranslations } from './notificationTranslations';
import { defaultNotificationGroupOverviewTranslations } from './notificationTranslations';

type Props = {
  car: CarGroup;
  translations?: NotificationGroupOverviewTranslations;
};

/** The car's driver as one table cell: who is reached, and whether they are reachable at all. */
export const CarDriverSummary = ({ car, translations: t = defaultNotificationGroupOverviewTranslations }: Props) => {
  const driver = car.manager;

  if (!driver) {
    return (
      <span className='flex min-w-0 items-center gap-2'>
        <span className='flex size-6 shrink-0 items-center justify-center rounded-full border border-dashed border-muted-foreground/60'>
          <NoddiIcon name='Plus' size='xSmall' />
        </span>
        <span className='truncate text-sm text-muted-foreground'>{t.noDriver}</span>
      </span>
    );
  }

  return (
    <span className='flex min-w-0 items-center gap-2'>
      <WorkerAvatar name={`${driver.firstName} ${driver.lastName}`} size='sm' className='shrink-0' />
      <span className='flex min-w-0 flex-col'>
        <span className={cn('truncate text-sm', isSilenced(driver) && 'text-muted-foreground')}>
          {`${driver.firstName} ${driver.lastName}`}
        </span>
        {isSilenced(driver) && (
          <NoddiBadge variant='warning' className='w-fit px-1.5 py-0 text-[10px]'>
            {t.smsTurnedOff}
          </NoddiBadge>
        )}
      </span>
    </span>
  );
};
